import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Card, CardActions, CardContent, Chip, Stack, Typography } from '@mui/material';
import type { ExternalReviewPackageListItem } from '../../domain/externalReview/mapExternalReviewPackageList';

type Props = {
  item: ExternalReviewPackageListItem;
};

export default function ExternalReviewPackageCard({ item }: Props) {
  return (
    <Card variant="outlined" data-testid={`external-review-package-${item.reportId}`}>
      <CardContent>
        <Stack spacing={1.25}>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
            <Typography variant="h6" component="h2" fontWeight={700}>
              {item.title}
            </Typography>
            <Chip size="small" label={item.statusLabel} variant="outlined" color="success" />
            {item.isDemoOrLoopedSource ? (
              <Chip size="small" label="Controlled demo" variant="outlined" />
            ) : null}
          </Stack>
          <Typography variant="body2" color="text.secondary">
            Assigned Signed Safety Scan package for external review.
          </Typography>
          <Typography variant="body2">
            <strong>Where:</strong> {item.areaLabel}
          </Typography>
          <Typography variant="body2">
            <strong>Scan window:</strong> {item.scanWindowLabel}
          </Typography>
        </Stack>
      </CardContent>
      <CardActions sx={{ px: 2, pb: 2 }}>
        <Button
          component={RouterLink}
          to={item.reviewPath}
          variant="contained"
          data-testid={`open-external-review-${item.reportId}`}
        >
          Open Safety Review Package
        </Button>
      </CardActions>
    </Card>
  );
}
